import { render } from "./uiNavigationUnderlineTabsItem.vue?vue&type=template&id=f5e1f05e&scoped=true"
import script from "./uiNavigationUnderlineTabsItem.vue?vue&type=script&lang=js"
export * from "./uiNavigationUnderlineTabsItem.vue?vue&type=script&lang=js"

import "./uiNavigationUnderlineTabsItem.vue?vue&type=style&index=0&id=f5e1f05e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e1f05e"]])

export default __exports__